import React from "react";
import {
    Button,
    IconButton,
    Link,
    Stack
} from "@chakra-ui/react";


export default function ButtonStack(props) {
    const { items = [], size, ...rest } = props;

    return (
        <Stack className={"button-stack"} {...rest}>
            {items.map((item, i) => (
                <Link href={item.url} key={i} target={"_blank"}>
                    {
                        item.icon == undefined ? (
                            <Button size={size}>{item.text}</Button>
                        ) : (
                            <IconButton size={size} icon={<item.icon />} />
                        )
                    }
                </Link>
            ))}
        </Stack>
    );
}
